module.exports = "/_next/static/images/loyality-3ea659f38786699fb9ace82b78745a00.svg";